import React from "react";

export const Form = ({ welcome, submitBtn, setEmail, setPassword, login }) => {

    return (
        <div className="col-sm-5 bg-info rounded shadow p-5 text-light">
            <h2>{welcome}</h2>

            <div className="form-group">

                <label htmlFor="Email" className="form-label">Email</label>
                <input placeholder="Email..." className="form-control" onChange={(event) => {
                    setEmail(event.target.value);
                }} />

                <label htmlFor="Password" className="form-label">Senha</label>
                <input placeholder="Senha..." className="form-control pb-2" type={"password"} onChange={(event) => {
                    setPassword(event.target.value);
                }} />

                {/*TODO: add login with google button*/}

                <button onClick={login} className="btn btn-secondary form-control mt-4">{submitBtn}</button>
            </div>

        </div>
    )
}

export default Form;